module.exports = __webpack_public_path__ + "static/clutch-logo-noslogan.a32419d9.svg";